"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const EscudoSeguridadM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 17.8 18.489" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M15.043 11.546a72.961 72.961 0 00.374-7.963 4.754 4.754 0 01-3.252-1.215 4.928 4.928 0 00-3.178-1.237A4.913 4.913 0 005.8 2.368a4.75 4.75 0 01-3.249 1.215 71.825 71.825 0 00.379 7.963c.357 2.241 4.3 4.8 6.054 5.748 1.758-.949 5.704-3.512 6.059-5.748zm1.408-8.6a82.016 82.016 0 01-.389 8.792c-.539 3.391-6.6 6.561-6.855 6.7a.48.48 0 01-.442 0c-.257-.132-6.311-3.3-6.85-6.693a79.969 79.969 0 01-.4-8.792.592.592 0 01.2-.445.487.487 0 01.442-.1 3.6 3.6 0 003.072-.979A5.864 5.864 0 018.984 0h.007a5.872 5.872 0 013.749 1.426 3.619 3.619 0 003.091.976.5.5 0 01.427.126.6.6 0 01.192.421zm-8.756 8.066l4.32-4.735a.486.486 0 01.731 0 .6.6 0 010 .8l-4.685 5.135a.483.483 0 01-.729 0L5.23 9.9a.6.6 0 010-.8.486.486 0 01.731 0z" }))));
};
exports.default = EscudoSeguridadM;
//# sourceMappingURL=index.js.map